"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = verify;

function verify(obj) {
  if (obj.hasOwnProperty('get') || obj.hasOwnProperty('set') || obj.hasOwnProperty('pure') || obj.hasOwnProperty('environment')) {
    throw Error(`config can't have keys "get", "set", "pure", or "environment"`);
  }
}